import React, { useState } from 'react';
import { AuthAPI } from '../utils/api';

const LoginTest = () => {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const testLogin = async () => {
    setLoading(true);
    setResult('Testing login...');
    
    try {
      console.log('Testing login with testuser@example.com');
      const response = await AuthAPI.login({
        email: 'testuser@example.com',
        password: 'testpassword123'
      });
      
      console.log('Login response:', response);
      setResult(`SUCCESS: ${JSON.stringify(response.data, null, 2)}`);
    } catch (error) {
      console.error('Login test error:', error);
      setResult(`ERROR: Status ${error.response?.status} - ${error.response?.data?.detail || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h2>Login Test Component</h2>
      <button onClick={testLogin} disabled={loading}>
        {loading ? 'Testing...' : 'Test Login'}
      </button>
      <pre style={{ marginTop: '10px', background: '#f5f5f5', padding: '10px', whiteSpace: 'pre-wrap' }}>
        {result}
      </pre>
    </div>
  );
};

export default LoginTest;
